<template>
  <div id="video-detail">
    <core-header/>
    <v-container>
      <v-row>
        <v-col>
          <h3>{{ video.videoName }}</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          {{ video.totalPlayNum }}播放
        </v-col>

        <v-col cols="4" align="end">
          <v-btn
              @click="$router.go(-1)"
          >
            返回
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <vue-aliplayer-v2
              :source="video.tmpVideoUrl"
              ref="VueAliplayerV2"
              :options="options"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span>{{ video.videoIntrodution }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
              color="success"
              @click="downloadVideo"
          >
            下载
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" v-for="item in videos" :key="item.videoName">
          <video-card
              class="grid-item"
              :size="false"
              :value="item"
          ></video-card>
        </v-col>
        <v-col md="2">
          <base-card
              class="grid-item"
              height="100%"
              width="100%"
              @click="$router.push({ path: '/channel', query: { 'channelId': video.channelId } })"
          >
            查看更多
          </base-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VueAliplayerV2 from "vue-aliplayer-v2";
import * as videoApi from "@/servers/video";

export default {
  name: 'VideoDetail',
  components: {
    CoreHeader: () => import('@/components/core/Header'),
    VideoCard: () => import('@/components/video/VideoCard'),
    VueAliplayerV2
  }, data() {
    return {
      options: {
        // source:'//player.alicdn.com/video/aliyunmedia.mp4',
        isLive: false, //切换为直播流的时候必填
        // format: 'm3u8'  //切换为直播流的时候必填
        preload: true,
        autoplay: true,
        height: "600px",
      },
      source: "//player.alicdn.com/video/aliyunmedia.mp4",
      // source: '//ivi.bupt.edu.cn/hls/cctv1.m3u8',
      show: true,
      isShowMultiple: false,
      video: {},
      videos: []
    };
  },

  methods: {
    loadData() {
      let that = this;
      let query = this.$route.query;
      if (query && query.id) {
        let id = query.id;
        videoApi.videoDetail(id)
            .then(res => {
              that.video = res;
              that.loadVideoListForDetail();
            });
      }
    },
    loadVideoListForDetail() {
      let that = this;
      videoApi.videoListForDetail({
        "channelId": that.video.channelId,
        "classId": that.video.classId,
        "id": that.video.id
      })
          .then(res => {
            that.videos = res;
          });
    },
    downloadVideo() {

      fetch(this.video.tmpVideoUrl)
          .then(res => res.blob())
          .then(blob => {
            const a = document.createElement("a");
            const objectUrl = window.URL.createObjectURL(blob);
            a.download = this.video.videoName;
            a.href = objectUrl;
            a.click();
            window.revokeObjectURL(objectUrl);
          })
    },
    play() {
      this.$refs.VueAliplayerV2.play();
    },

    pause() {
      this.$refs.VueAliplayerV2.pause();
    },

    replay() {
      this.$refs.VueAliplayerV2.replay();
    },

    getCurrentTime() {
      // this.$refs.VueAliplayerV2.getCurrentTime();
      this.source = "http://ivi.bupt.edu.cn/hls/cctv1.m3u8";
    },

    getStatus() {
      const status = this.$refs.VueAliplayerV2.getStatus();
      console.log(`getStatus:`, status);
      alert(`getStatus:${status}`);
    },

    showMultiple() {
      this.isShowMultiple = !this.isShowMultiple;
    },
  },
  created() {
    this.loadData();
  },
  watch: {
    '$route'() {
      this.loadData();
    }
  }
}
</script>
<style scoped>

.grid-item {
  box-sizing: border-box;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bolder;
  font-size: 1rem;
  width: 100%;
  height: 100%;
}
</style>
